export enum DepositStatus {
    INITIATED = 'initiated',
    PENDING = 'pending',
    COMPLETED = 'completed',
    CREDITED = 'credited',
    FAILED = 'failed',
    CANCELED = 'canceled',
    UNKNOWN = 'unknown'
}

export enum PaymentMethod {
    Stripe = 'Stripe',
    CryptoChill = 'CryptoChill'
}

export interface StripeDepositCard {
    brand?: string
    last4?: string
    expMonth?: number
    expYear?: number
    funding?: string
    country?: string
    network?: string
    wallet?: string
    threeDSecure?: string
}

export interface StripeDepositOutcome {
    networkStatus?: string
    reason?: string
    riskLevel?: string
    riskScore?: number
    sellerMessage?: string
    type?: string
}

export interface StripeDepositBillingAddress {
    city?: string
    country?: string
    line1?: string
    line2?: string
    postalCode?: string
    state?: string
}

export interface StripeDepositTaxId {
    type: string
    value: string
}

export interface StripeDepositMetadata {
    sessionId: string
    eventType?: string
    mode?: string
    sessionStatus?: string
    paymentStatus?: string

    amountTotal?: number // cents
    amountSubtotal?: number // cents
    amountDiscount?: number // cents
    amountTax?: number // cents
    amountShipping?: number // cents
    currency?: string

    clientReferenceId?: string
    createdAt?: number // unix seconds (Stripe), NOT the Mongo createdAt
    paymentMethodTypes?: string[]

    customerId?: string
    customerEmail?: string
    customerName?: string
    customerPhone?: string
    billingAddress?: StripeDepositBillingAddress
    taxIds?: StripeDepositTaxId[]

    paymentIntentId?: string
    paymentIntentStatus?: string

    chargeId?: string
    balanceTransactionId?: string
    receiptUrl?: string // link to the Stripe receipt
    receiptEmail?: string
    paid?: boolean
    amountCaptured?: number // cents

    paymentMethodType?: string
    card?: StripeDepositCard
    outcome?: StripeDepositOutcome

    transaction?: string // ledger Transaction id (set once the deposit is credited)
    bonus?: number // affiliate bonus in cents (set once credited)
}

export interface IDeposit {
    _id: string
    user: string

    method: PaymentMethod
    status: DepositStatus
    amount: number
    currency: string

    externalId?: string

    code?: string

    metadata?: StripeDepositMetadata & Record<string, unknown>

    createdAt?: Date
    updatedAt?: Date
}

export type DepositSortField = 'createdAt' | 'amount' | 'status' | 'method'
export type SortDirection = 'asc' | 'desc'

export interface IDepositQuery {
    page: number
    limit: number
    user?: string
    search?: string
    methods?: string[]
    statuses?: string[]
    dateFrom?: string
    dateTo?: string
    amountMin?: number
    amountMax?: number
    sortField?: DepositSortField
    sortDir?: SortDirection
    includeSummary?: boolean
}

export interface IDepositSummary {
    totalCount: number
    totalAmount: number
    byStatus: Partial<Record<DepositStatus, { count: number; amount: number }>>
    byMethod: Partial<Record<PaymentMethod, { count: number; amount: number }>>
}

export interface ICryptoAddress {
    address: string
    invoiceId?: string
}

export type CryptoAddressMap = Record<string, ICryptoAddress>
